import { getLang } from '../../utils/translate-module';
import { addError, removeError } from '../../utils/form-validation';
import { modals } from  '../../blocks-ui/modals/modals';

(function() {
    const form = document.querySelector('.js-subscribe-form');
    const formInput = {
      email: form.querySelector('#subscribe-email'),
      password: form.querySelector('#subscribe-password')
    };

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      if (!formData.get('agree')) {
        addError(form.querySelector('[name="agree"]'));
        return;
      }

      formData.append('cp', formData.get('p'));
      const data = {};
      formData.delete('agree');
      formData.forEach(function(value, key){
        data[key] = value;
      });

      const lang = getLang().toUpperCase();
      const url = `${ process.env.API }/api/users/register?page=referral&lang=${ lang }`;


      fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then((response) => {
        const r = response.json();
        if (!response.ok) {
          return r.then((err) => { throw err });
        }
        return r;
      })
      .then(() => {
        modals.open('success-modal');
        form.reset();
      })
      .catch((err) => {
        if (!err && !err.messages) {
          return;
        }

        err.messages.forEach(({ propertyName, message }) => {
          if (propertyName !== 'email' && propertyName !== 'password')  {
            return;
          }
          const input = formInput[propertyName];
          addError(input, message);
        });

      });

    });

    form.addEventListener('input', (e) => {
      const input = e.target;
      removeError(input);
    })
})();